module.exports = __webpack_public_path__ + "img/R.cf065404.jpg";